var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('v-row',{staticClass:"mt-3",attrs:{"justify":"center"}},[_c('v-img',{attrs:{"src":_vm.imagen,"contain":"","height":"200"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }